import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Typography(theme: Theme, containerId: string) {
  return {
    MuiTypography: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
